<template>
  <p :class="$style.statusVacation">休暇中</p>
</template>

<style module lang="scss">
.statusVacation {
  color: $text-color-disabled;
  font-size: 14px;

  &::before {
    background-color: var(--color-red);
    border-radius: 50%;
    content: '';
    display: inline-block;
    height: 12px;
    margin-right: 6px;
    position: relative;
    top: 1px;
    width: 12px;
  }
}
</style>
